import { saveUserCache } from '@/lib/storageUtil';
import useLogout from '@authentication/hooks/useLogout';
import useAuth from '@authentication/hooks/useAuth';
import LoginRequest from '@authentication/models/login.request.dto';
import LoginResponse from '@authentication/models/login.response.dto';
import { login } from '@authentication/services/authServices';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

const useLoginMutation = (): UseMutationResult<
  AxiosResponse<LoginResponse>,
  unknown,
  LoginRequest,
  unknown
> => {
  const { setUser, setIsLoading } = useAuth();

  const logout = useLogout();

  const onLoginSuccess = ({ data }: { data: LoginResponse }) => {
    setUser(data.user);
    saveUserCache(data);
    setIsLoading(false);
  };

  const onLoginError = () => {
    logout();
    setUser(null);
    setIsLoading(false);
  };
  const loginMutation = useMutation({
    mutationFn: login,
    onSuccess: onLoginSuccess,
    onError: onLoginError,
  });

  return loginMutation;
};

export default useLoginMutation;
